module.exports = __webpack_public_path__ + "img/User.f395705b.svg";